import { Button } from "@legal-500/legal500-design-system";
import styles from "./MailingGroups.module.css";

type Props = {
  // True when "select all matching" (filter) mode is active.
  selectAllActive: boolean;
  // True when every row currently on the page is selected.
  allOnPageSelected: boolean;
  pageCount: number;
  total: number;
  excludedCount: number;
  onSelectAllMatching: () => void;
  onClear: () => void;
};

// Gmail-style banner sitting above the table. In filter mode it reports the
// whole matching set (minus exclusions); when a full page is hand-picked it
// offers to escalate the selection to every matching recipient.
export function SelectAllBanner({
  selectAllActive,
  allOnPageSelected,
  pageCount,
  total,
  excludedCount,
  onSelectAllMatching,
  onClear,
}: Props) {
  if (selectAllActive) {
    return (
      <div className={styles.selectAllBanner}>
        <span className={styles.selectAllBannerInfo}>
          All {total.toLocaleString()} recipient{total === 1 ? "" : "s"} matching this filter are
          selected
          {excludedCount > 0 ? ` · ${excludedCount.toLocaleString()} excluded` : ""}.
        </span>
        <Button variant="outlined" color="primary" size="small" onClick={onClear}>
          Clear selection
        </Button>
      </div>
    );
  }

  if (allOnPageSelected) {
    return (
      <div className={styles.selectAllBanner}>
        <span className={styles.selectAllBannerInfo}>All {pageCount} on this page selected.</span>
        <Button variant="outlined" color="primary" size="small" onClick={onSelectAllMatching}>
          Select all {total.toLocaleString()} matching this filter
        </Button>
      </div>
    );
  }

  return null;
}
